import React from 'react';
import {Button} from "semantic-ui-react";
import SvgNew from "../../../components/SvgNew";

const HeaderButton = ({name, icon, onClick, disabled, withLeftLine}) => {
    return (
        <Button className={`header-btn ${withLeftLine ? 'right-line' : ''}`} onClick={onClick} disabled={disabled}>
            <SvgNew name={icon}/>
            <div className='header-btn__label'>{name}</div>
        </Button>
    );
};

export default HeaderButton;


// WEBPACK FOOTER //
// ./App/pages/reports/components/button.jsx